import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export interface ValidateBillingDataResponse {
  hasCompleteBillingInformation: boolean;
}

const validateBillingInformation = (makeCall: MakeCall) => (userId: number) =>
  makeCall<ValidateBillingDataResponse>(
    'GET',
    `/v1/user/${userId}/validate-billing-data`,
  );

export default validateBillingInformation;

export type ValidateBillingInformation = ReturnType<
  typeof validateBillingInformation
>;
